export const siteData = {
  name: "ITS Academy",
  tagline: "Empowering Saharanpur Since 2001",
  established: "July 2001",
  phone: ["+91 7669669222", "0132 3590500"],
  email: "itsacademy786@gmail.com",
  rating: "4.9",
  reviews: "1500+",
  students: "15000+",
  yearsActive: "24+",
  courses: "400+",
  branches: "4+",
  headOffice: "6/2648, Chipiyan Chakrota Road, Opposite S.D. Inter College,Saharanpur – 247001, Uttar Pradesh, India",
  allBranches: [
    { label: "Head Office", address: "6/2648, Chipiyan Chakrota Road, Opp. S.D. Inter College, Saharanpur – 247001" },
    { label: "Branch 1", address: "Opp. Maharaj Singh Degree College, Ghadi Malook, Old Madhu Nagar, Bansal Dairy, Saharanpur – 247001" },
    { label: "Branch 2", address: "Mandi Samiti Road, Aali Ki Chungi, Near Mysore Place, Saharanpur – 247001" },
    { label: "Branch 3", address: "Kailashpur Bus Stand, Dehradun Road, Saharanpur – 247001" },
  ],
  social: {
    facebook: "https://www.facebook.com/p/ITS-Academy-Computer-Center-100066838118899/",
    instagram: "https://www.instagram.com/itsacademycomputereducation/",
    youtube: "https://www.youtube.com/@itsacademycomputereducatio8227",
    google: "https://share.google/2nXMIL8dPpA1o1AsL",
  },
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Courses", href: "#courses" },
  { label: "Facilities", href: "#facilities" },
  { label: "Mission", href: "#mission" },
  { label: "Affiliations", href: "#affiliations" },
  { label: "Achievements", href: "#achievements" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const stats = [
  { value: 24, suffix: "+", label: "Years of Excellence" },
  { value: 400, suffix: "+", label: "Courses Offered" },
  { value: 15000, suffix: "+", label: "Happy Students" },
  { value: 4, suffix: "+", label: "Branches" },
];

export const courses = [
  {
    id: 1,
    icon: "💻",
    name: "IT Fundamentals",
    color: "from-blue-500/20 to-blue-600/5",
    border: "border-blue-500/20",
    glow: "shadow-blue-500/10",
    description: "From basics to advanced — BCC, CCC, DCA, ADCA, O Level, A Level. NIELIT affiliated programs with government-recognized certificates.",
    levels: ["Basic", "Intermediate", "Advanced", "Professional"],
    courses: ["Computer Fundamentals", "BCC (NIELIT)", "CCC (NIELIT)", "DCA", "ADCA", "O Level (NIELIT)", "A Level (NIELIT)", "Full Stack Computer Course"],
    count: 29,
  },
  {
    id: 2,
    icon: "📐",
    name: "AutoCAD",
    color: "from-orange-500/20 to-orange-600/5",
    border: "border-orange-500/20",
    glow: "shadow-orange-500/10",
    description: "2D & 3D drafting, civil, mechanical, architectural, and electrical AutoCAD for engineers and designers.",
    levels: ["Basic", "Intermediate", "Advanced", "Specialized"],
    courses: ["AutoCAD Fundamentals", "2D Drafting", "3D Modeling & Rendering", "AutoCAD for Civil", "AutoCAD for Mechanical", "AutoCAD for Architecture"],
    count: 20,
  },
  {
    id: 3,
    icon: "🌐",
    name: "Hardware & Networking",
    color: "from-green-500/20 to-green-600/5",
    border: "border-green-500/20",
    glow: "shadow-green-500/10",
    description: "PC assembly, troubleshooting, network administration, CCNA prep, and IT infrastructure management.",
    levels: ["Basic", "Intermediate", "Advanced", "Professional"],
    courses: ["Computer Hardware Fundamentals", "PC Assembly & Troubleshooting", "Hardware & Networking Engineer", "Network Security", "IT Support & Network Technician"],
    count: 25,
  },
  {
    id: 4,
    icon: "📊",
    name: "Tally & Accounting",
    color: "from-yellow-500/20 to-yellow-600/5",
    border: "border-yellow-500/20",
    glow: "shadow-yellow-500/10",
    description: "Tally Prime, GST, Income Tax, practical accounting training for job readiness in finance.",
    levels: ["Basic", "Intermediate", "Advanced", "Career-Oriented"],
    courses: ["Tally with GST", "Advanced Tally with GST & Taxation", "Tally ERP 9 / Tally Prime", "Business Accounting & Taxation", "Accounts Executive Training"],
    count: 25,
  },
  {
    id: 5,
    icon: "🎨",
    name: "Graphic Design",
    color: "from-pink-500/20 to-pink-600/5",
    border: "border-pink-500/20",
    glow: "shadow-pink-500/10",
    description: "Photoshop, Illustrator, CorelDRAW, Adobe Creative Suite. From logo design to full branding campaigns.",
    levels: ["Basic", "Intermediate", "Advanced", "Software-Based"],
    courses: ["Graphic Design with Photoshop", "Illustrator & InDesign", "CorelDRAW", "Adobe Creative Suite", "Professional Graphic Designer"],
    count: 19,
  },
  {
    id: 6,
    icon: "📱",
    name: "Digital Marketing",
    color: "from-purple-500/20 to-purple-600/5",
    border: "border-purple-500/20",
    glow: "shadow-purple-500/10",
    description: "SEO, SEM, Social Media, Google Ads, Content Marketing, E-Commerce and Affiliate Marketing.",
    levels: ["Basic", "Intermediate", "Advanced", "Specialized"],
    courses: ["SEO Specialist Course", "Social Media Marketing", "Google Ads & PPC", "Content & Email Marketing", "Digital Marketing Master Course"],
    count: 25,
  },
  {
    id: 7,
    icon: "⌨️",
    name: "Typing & Data Entry",
    color: "from-cyan-500/20 to-cyan-600/5",
    border: "border-cyan-500/20",
    glow: "shadow-cyan-500/10",
    description: "English & Hindi typing (Kruti Dev / Mangal), government exam preparation, speed & accuracy.",
    levels: ["Basic", "Intermediate", "Advanced"],
    courses: ["English Typing", "Hindi Typing (Kruti Dev)", "Hindi Typing (Mangal)", "Speed & Accuracy Typing", "Data Entry Professional"],
    count: 20,
  },
  {
    id: 8,
    icon: "🧑‍💻",
    name: "Programming Languages",
    color: "from-indigo-500/20 to-indigo-600/5",
    border: "border-indigo-500/20",
    glow: "shadow-indigo-500/10",
    description: "C, C++, Java, Python, HTML/CSS/JS — from logic building to full-stack software development.",
    levels: ["Basic", "Intermediate", "Advanced", "Career-Oriented"],
    courses: ["C Programming", "C++", "Java", "Python", "HTML/CSS/JavaScript", "Full Stack Development"],
    count: 25,
  },
  {
    id: 9,
    icon: "💬",
    name: "Spoken English",
    color: "from-teal-500/20 to-teal-600/5",
    border: "border-teal-500/20",
    glow: "shadow-teal-500/10",
    description: "Everyday to professional business communication, interview preparation and competitive exams.",
    levels: ["Basic", "Intermediate", "Advanced", "Career-Oriented"],
    courses: ["English Speaking Basics", "Certificate in Spoken English", "Business English", "English for Interviews", "Personality Development"],
    count: 25,
  },
  {
    id: 10,
    icon: "👗",
    name: "Fashion Design",
    color: "from-rose-500/20 to-rose-600/5",
    border: "border-rose-500/20",
    glow: "shadow-rose-500/10",
    description: "Fashion illustration, garment construction, styling, textile design, and entrepreneurship.",
    levels: ["Basic", "Intermediate", "Advanced", "Specialized"],
    courses: ["Fashion Illustration & Sketching", "Apparel & Garment Design", "Fashion Styling & Trend Analysis", "Fashion Branding", "Fashion Entrepreneurship"],
    count: 25,
  },
  {
    id: 11,
    icon: "💄",
    name: "Beautician / Parlor",
    color: "from-fuchsia-500/20 to-fuchsia-600/5",
    border: "border-fuchsia-500/20",
    glow: "shadow-fuchsia-500/10",
    description: "10-module comprehensive beauty course: skincare, hair, makeup, nail art, waxing & salon management.",
    levels: ["Beginner", "Intermediate", "Advanced"],
    courses: ["Skin Care", "Hair Care & Styling", "Makeup Techniques", "Nail Care & Manicure/Pedicure", "Waxing & Hair Removal", "Salon Management"],
    count: 58,
  },
  {
    id: 12,
    icon: "🛒",
    name: "E-Commerce",
    color: "from-amber-500/20 to-amber-600/5",
    border: "border-amber-500/20",
    glow: "shadow-amber-500/10",
    description: "Amazon/Flipkart selling, Shopify, WooCommerce, online business strategy and digital entrepreneurship.",
    levels: ["Basic", "Intermediate", "Advanced", "Platform-Based"],
    courses: ["Amazon & Flipkart Seller Course", "Shopify & WooCommerce", "E-Commerce Website Development", "Online Business & Entrepreneurship", "E-Commerce Master Course"],
    count: 25,
  },
];

export const facilities = [
  { icon: "📚", name: "Smart Classrooms", desc: "Fully ventilated, spacious rooms with smart boards, projector-based digital learning, comfortable seating and regular cleanliness.", tags: ["Smart Boards", "AC", "Projectors", "Digital Learning"] },
  { icon: "👩‍🏫", name: "Expert Faculty", desc: "Highly qualified teachers with 15–24+ years of experience, regular doubt-clearing sessions, personal mentoring and weekly performance reviews.", tags: ["24+ Yrs Exp", "Mentoring", "Weekly Review"] },
  { icon: "🔬", name: "Computer Labs", desc: "Modern, well-equipped labs with high-speed internet, latest licensed software, and updated hardware for hands-on practical training.", tags: ["High-Speed Internet", "Latest Software", "Updated Hardware"] },
  { icon: "📖", name: "Library", desc: "Wide collection of academic books, competitive exam material, daily newspapers and a silent, disciplined study environment.", tags: ["Academic Books", "Exam Material", "Silent Zone"] },
  { icon: "🏆", name: "Co-Curricular", desc: "Debates, quizzes, sports, personality development workshops, cultural programs and annual functions for holistic development.", tags: ["Debates", "Sports", "Workshops", "Annual Events"] },
  { icon: "🛡️", name: "Safety & Security", desc: "24/7 CCTV surveillance, disciplined campus, separate washroom facilities and first-aid always available for student safety.", tags: ["CCTV 24/7", "First Aid", "Disciplined Campus"] },
  { icon: "💻", name: "Online Support", desc: "Online classes facility, study materials in PDF format, and regular updates via WhatsApp to keep learning accessible anywhere.", tags: ["Online Classes", "PDF Materials", "WhatsApp Updates"] },
  { icon: "🚌", name: "Transport", desc: "Safe and reliable transport service with experienced drivers, fixed routes and timings for students across Saharanpur.", tags: ["Safe Routes", "Fixed Timings", "Experienced Drivers"] },
];

export const affiliations = [
  { name: "NIELIT", fullName: "National Institute of Electronics & IT", desc: "Government-affiliated BCC, CCC, O Level, A Level programs with nationally recognized certificates.", logo: "/images/affiliations/nielit.png", color: "blue" },
  { name: "NITI", fullName: "National IT Institute", desc: "Government-recognized digital skills and IT certification programs enhancing employability.", logo: "/images/affiliations/niti.png", color: "green" },
  { name: "Industry Partners", fullName: "IT Companies & Local Businesses", desc: "Collaborations with IT firms for practical industry exposure, internships and job placements.", logo: "/images/affiliations/industry.png", color: "orange" },
  { name: "Govt. Recognized", fullName: "Education Authority Recognized", desc: "Certificates valid for government & private sector employment across India.", logo: "/images/affiliations/govt.png", color: "purple" },
  { name: "ISO Certified", fullName: "Quality Management Standard", desc: "Regular audits, licensed software and updated hardware maintaining highest training standards.", logo: "/images/affiliations/iso.png", color: "red" },
  { name: "Digital India", fullName: "Digital India Initiative", desc: "Aligned with Government of India's Digital India mission for digital empowerment of citizens.", logo: "/images/affiliations/digital-india.png", color: "teal" },
];

export const reviews = [
  { name: "Rahul Sharma", course: "DCA Graduate", rating: 5, review: "The best computer institute in Saharanpur! Faculty is extremely knowledgeable and patient. Got a job within 2 months of completing DCA. Highly recommend!", avatar: "RS" },
  { name: "Priya Singh", course: "Tally & GST", rating: 5, review: "ITS Academy changed my life. The Tally with GST course was practical and thorough. Now I work as an accountant — I owe it all to this institute.", avatar: "PS" },
  { name: "Amit Kumar", course: "Digital Marketing", rating: 5, review: "Excellent training in Digital Marketing! Hands-on projects and real-world assignments made all the difference. Now running my own agency.", avatar: "AK" },
  { name: "Neha Gupta", course: "Graphic Design", rating: 5, review: "The Graphic Design course was fantastic! Learned Photoshop and Illustrator professionally. Now running my own freelance design business!", avatar: "NG" },
  { name: "Suresh Yadav", course: "CCC — NIELIT", rating: 5, review: "The CCC course affiliated with NIELIT gave me government-recognized certification. Very professional institute with modern labs and kind staff.", avatar: "SY" },
  { name: "Kavita Rawat", course: "ADCA Graduate", rating: 5, review: "Wonderful place to learn! Teachers are experienced, helpful and motivating. Classrooms are clean and well-equipped. Absolute 10/10!", avatar: "KR" },
  { name: "Mohammad Irfan", course: "Hardware & Networking", rating: 5, review: "The Hardware & Networking course gave me practical skills I use daily at my job. The labs are excellent and the faculty truly cares about students.", avatar: "MI" },
  { name: "Anjali Verma", course: "Spoken English", rating: 5, review: "My confidence has transformed completely. The Spoken English course here is unlike any other. Real practice, real improvement. Thank you ITS Academy!", avatar: "AV" },
  { name: "Deepak Saini", course: "AutoCAD", rating: 5, review: "Joined AutoCAD Civil course and the trainer was exceptional. Got placed in a construction firm within a month. Best investment of my career!", avatar: "DS" },
  { name: "Sunita Tyagi", course: "Beautician Course", rating: 5, review: "The 10-module beautician course is incredibly comprehensive. Now I run my own salon! The practical sessions were the highlight.", avatar: "ST" },
];

export const galleryImages = [
  { src: "/images/gallery/1 (1).jpg", alt: "", category: "Campus" },
  { src: "/images/gallery/2.jpg", alt: "", category: "Labs" },
  { src: "/images/gallery/3.jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/4.jpg", alt: "", category: "Students" },
  { src: "/images/gallery/5.jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (6).jpg", alt: "", category: "Events" },
  { src: "/images/gallery/1 (7).jpg", alt: "", category: "Faculty" },
  { src: "/images/gallery/1 (8).jpg", alt: "", category: "Events" },
  { src: "/images/gallery/1 (9).jpg", alt: "", category: "Labs" },
  { src: "/images/gallery/1 (10).jpg", alt: "", category: "Labs" },
  { src: "/images/gallery/1 (11).jpg", alt: "", category: "Events" },
  { src: "/images/gallery/1 (12).jpg", alt: "", category: "Students" },
  { src: "/images/gallery/1 (13).jpg", alt: "", category: "Labs" },
  { src: "/images/gallery/1 (14).jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/1 (15).jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/1 (16).jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/1 (17).jpg", alt: "", category: "Labs" },
  { src: "/images/gallery/1 (18).jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/1 (19).jpg", alt: "", category: "Classes" },
  { src: "/images/gallery/1 (20).jpg", alt: "", category: "Students" },
  { src: "/images/gallery/1 (21).jpg", alt: "", category: "Faculty" },
  { src: "/images/gallery/1 (22).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (23).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (24).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (25).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (26).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (27).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (28).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (29).jpg", alt: "", category: "Training" },
  { src: "/images/gallery/1 (30).jpg", alt: "", category: "Training" },
];

export const achievements = [
  { title: "Best Computer Institute Award", year: "2023", org: "Saharanpur Education Board", img: "/images/achievements/award-1.jpg" },
  { title: "NIELIT Excellence Certificate", year: "2022", org: "NIELIT India", img: "/images/achievements/cert-1.jpg" },
  { title: "Digital India Recognition", year: "2022", org: "Government of India", img: "/images/achievements/cert-2.jpg" },
  { title: "Quality Education Award", year: "2021", org: "UP Education Department", img: "/images/achievements/award-2.jpg" },
  { title: "Outstanding IT Training", year: "2020", org: "IT Industry Association", img: "/images/achievements/cert-3.jpg" },
  { title: "Community Impact Award", year: "2019", org: "Saharanpur District", img: "/images/achievements/award-3.jpg" },
  { title: "Best Faculty Recognition", year: "2018", org: "Education Excellence Forum", img: "/images/achievements/cert-4.jpg" },
  { title: "Innovation in Education", year: "2017", org: "State Education Authority", img: "/images/achievements/award-4.jpg" },
];

export const marqueeItems = [
  "Computer Education", "Digital Marketing", "Graphic Design", "Tally & Accounting",
  "Hardware & Networking", "AutoCAD", "Programming Languages", "Fashion Design",
  "Spoken English", "NIELIT Affiliated", "Government Recognized", "E-Commerce",
  "Beautician Course", "Data Entry", "Web Development", "Software Development",
];
